import React, { useState } from 'react';
import { X } from 'lucide-react';
import { useFeatureFlags } from '../../hooks/useFeatureFlags';

// Banner thông báo toàn hệ thống — admin bật/soạn ở trang Settings (announce.enabled / announce.text / announce.link).
// Đóng được; ghi nhớ theo nội dung nên đổi thông báo mới sẽ hiện lại.
const DISMISS_KEY = 'cab-announce-dismissed';

const AnnouncementBanner = () => {
  const { get } = useFeatureFlags();
  const text = get('announce.text').trim();
  const link = get('announce.link').trim();
  const enabled = get('announce.enabled') === 'true'; // mặc định tắt

  const [dismissed, setDismissed] = useState<boolean>(() => {
    try {
      return localStorage.getItem(DISMISS_KEY) === text;
    } catch {
      return false;
    }
  });

  if (!enabled || !text || dismissed) return null;

  const close = () => {
    try {
      localStorage.setItem(DISMISS_KEY, text);
    } catch {
      /* ignore */
    }
    setDismissed(true);
  };

  const Content = (
    <span className="text-sm font-medium">{text}</span>
  );

  return (
    <div className="relative z-[120] bg-gradient-to-r from-blue-600 to-indigo-600 text-white">
      <div className="max-w-5xl mx-auto flex items-center justify-center gap-3 px-10 py-2 text-center">
        {link ? (
          <a href={link} target="_blank" rel="noreferrer" className="hover:underline">
            {Content}
          </a>
        ) : (
          Content
        )}
      </div>
      <button
        onClick={close}
        aria-label="Đóng thông báo"
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded hover:bg-white/20"
      >
        <X size={16} />
      </button>
    </div>
  );
};

export default AnnouncementBanner;
